import { render, staticRenderFns } from "./PopupMailchimpSettings.vue?vue&type=template&id=72a50d95&"
import script from "./PopupMailchimpSettings.vue?vue&type=script&lang=js&"
export * from "./PopupMailchimpSettings.vue?vue&type=script&lang=js&"
import style0 from "./PopupMailchimpSettings.vue?vue&type=style&index=0&id=72a50d95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports